import { render } from "./MicrosoftSsoComp.vue?vue&type=template&id=37434c2b"
import script from "./MicrosoftSsoComp.vue?vue&type=script&lang=js"
export * from "./MicrosoftSsoComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__